import {cloneDeep} from "lodash";

import "./report-settings-dialog.scss";


export const ReportSettingsDialogController = ($scope,
                                         $mdDialog, reportSettings, callback) => {
    "ngInject";
    $scope.callback = callback;
    $scope.reportSettings = cloneDeep(reportSettings);

    $scope.saveSettings = () => {
        $scope.callback($scope.reportSettings);
        $scope.closeDialog();
    };

    $scope.changeRelatedToggles = (toggle, value) => {
        switch (toggle) {
            case "Photo System":
                $scope.reportSettings.sessions = value;
                $scope.reportSettings.photo = value;
                $scope.reportSettings.gif = value;
                $scope.reportSettings.boomerang = value;
                $scope.reportSettings.video = value;
                $scope.reportSettings.emails = value;
                $scope.reportSettings.delivered = value;
                $scope.reportSettings.opens = value;
                $scope.reportSettings.clicks = value;
                $scope.reportSettings.messages = value;
                $scope.reportSettings.prints = value;
                $scope.reportSettings.qr_code_scans = value;
                break;
            case "Sessions":
                $scope.reportSettings.photo = value;
                $scope.reportSettings.gif = value;
                $scope.reportSettings.boomerang = value;
                $scope.reportSettings.video = value;
                value ? $scope.reportSettings.photo_system = true : $scope.isPhotoSystemTogglesActive();
                break;
            case "Emails":
                $scope.reportSettings.delivered = value;
                $scope.reportSettings.opens = value;
                $scope.reportSettings.clicks = value;
                value ? $scope.reportSettings.photo_system = true : $scope.isPhotoSystemTogglesActive();
                break;
            case "Live Gallery":
                $scope.reportSettings.views = value;
                $scope.reportSettings.avg_visit_time = value;
                $scope.reportSettings.downloads = value;
                $scope.reportSettings.whats_app = value;
                $scope.reportSettings.facebook = value;
                $scope.reportSettings.instagram = value;
                $scope.reportSettings.tiktok = value;
                $scope.reportSettings.mesenger = value;
                $scope.reportSettings.email = value;
                $scope.reportSettings.twitter = value;
                break;
        }
    };

    $scope.isGalleryTogglesActive = () => {
        if (!$scope.reportSettings.views &&
        !$scope.reportSettings.avg_visit_time &&
        !$scope.reportSettings.downloads &&
        !$scope.reportSettings.whats_app &&
        !$scope.reportSettings.facebook &&
        !$scope.reportSettings.instagram &&
        !$scope.reportSettings.tiktok &&
        !$scope.reportSettings.mesenger &&
        !$scope.reportSettings.email &&
        !$scope.reportSettings.twitter) {
            $scope.reportSettings.live_gallery = false;
        }
    };

    $scope.isPhotoSystemTogglesActive = () => {
        if (!$scope.reportSettings.sessions &&
            !$scope.reportSettings.photo &&
            !$scope.reportSettings.gif &&
            !$scope.reportSettings.emails &&
            !$scope.reportSettings.delivered &&
            !$scope.reportSettings.opens &&
            !$scope.reportSettings.clicks &&
            !$scope.reportSettings.messages &&
            !$scope.reportSettings.prints &&
            !$scope.reportSettings.qr_code_scans) {
            $scope.reportSettings.photo_system = false;
        }
    };

    $scope.setSessionsActive = () => {
        if ($scope.reportSettings.photo ||
            $scope.reportSettings.gif ||
            $scope.reportSettings.emails) {
            $scope.reportSettings.photo_system = true;
            $scope.reportSettings.sessions = true;
        }
    };

    $scope.setEmailActive = () => {
        if ($scope.reportSettings.delivered ||
            $scope.reportSettings.opens ||
            $scope.reportSettings.clicks) {
            $scope.reportSettings.photo_system = true;
            $scope.reportSettings.emails = true;
        }
    };

    $scope.closeDialog = () => {
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            $scope.create();
        }
    };
};



// WEBPACK FOOTER //
// ./sources/components/analytics/report-settings-dialog/report-settings-dialog.js